import * as React from 'react';
import { ConnectedFormSelect, TextArea } from '@grandvisionhq/forms';

const CancellationReasonField = ({ selectedCancellationType , labels , required  })=>{
    return /*#__PURE__*/ React.createElement("div", {
        className: "cancellation-reason-field"
    }, /*#__PURE__*/ React.createElement(ConnectedFormSelect, {
        id: "cancellationType",
        name: "cancellationType",
        label: labels.cancellationType.label,
        placeholder: labels.cancellationType.placeholder,
        errorMessage: labels.cancellationType.errorMessage,
        required: required,
        options: {
            [labels.cancellationType.options.ordinary]: {
                label: labels.cancellationType.options.ordinary,
                value: 'ORDINARY'
            },
            [labels.cancellationType.options.extraordinary]: {
                label: labels.cancellationType.options.extraordinary,
                value: 'EXTRAORDINARY'
            }
        }
    }), selectedCancellationType === 'ORDINARY' ? /*#__PURE__*/ React.createElement(ConnectedFormSelect, {
        id: "reasonOrdinary",
        name: "reasonOrdinary",
        label: labels.reason.label,
        placeholder: labels.reason.placeholder,
        errorMessage: labels.reason.errorMessage,
        required: required,
        options: {
            [labels.reason.options.changedPrescription]: {
                label: labels.reason.options.changedPrescription,
                value: 'CHANGED_PRESCRIPTION'
            },
            [labels.reason.options.notNeeded]: {
                label: labels.reason.options.notNeeded,
                value: 'NOT_NEEDED'
            },
            [labels.reason.options.tooExpensive]: {
                label: labels.reason.options.tooExpensive,
                value: 'TOO_EXPENSIVE'
            },
            [labels.reason.options.foundAnotherProduct]: {
                label: labels.reason.options.foundAnotherProduct,
                value: 'FOUND_ANOTHER_PRODUCT'
            },
            [labels.reason.options.deliveryProblems]: {
                label: labels.reason.options.deliveryProblems,
                value: 'DELIVERY_PROBLEMS'
            },
            [labels.reason.options.subscriptionManagementProblems]: {
                label: labels.reason.options.subscriptionManagementProblems,
                value: 'SUBSCRIPTION_MANAGEMENT_PROBLEMS'
            },
            [labels.reason.options.other]: {
                label: labels.reason.options.other,
                value: 'OTHER'
            }
        }
    }) : null, selectedCancellationType === 'EXTRAORDINARY' ? /*#__PURE__*/ React.createElement(TextArea, {
        id: "reasonExtraordinary",
        name: "reasonExtraordinary",
        label: labels.reason.label,
        placeholder: labels.reason.placeholder,
        errorMessage: labels.reason.errorMessage,
        maxLength: 200,
        required: required
    }) : null);
};

export { CancellationReasonField };
//# sourceMappingURL=CancellationReasonField.js.map
